/**
 * Customer reviews carousel (sections/testimonials.liquid).
 * A native scroll-snap track (swipe, trackpad and keyboard scrolling just work) plus prev/next
 * buttons that move one card at a time and disable at either end.
 */
// Several sections on one page can load this file; only the first run defines the element.
if (!customElements.get('review-carousel')) {
  class ReviewCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-review-track]');
      this.prev = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      if (!this.track) return;
  
      this.prev?.addEventListener('click', () => this.step(-1));
      this.next?.addEventListener('click', () => this.step(1));
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      window.addEventListener('resize', this.onResize = () => this.update());
      this.update();
    }
  
    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
    }
  
    step(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
    }
  
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max - 1;
    }
  }
  customElements.define('review-carousel', ReviewCarousel);
}
